import React, { useEffect, useState } from 'react';
import { EULA }  from './EULA';
import { appConstants } from '../../common/constants/constants';
import { getLegal } from '../../common/services/legal.service';
import { decodeApiResponse } from '../../common/utils/utility';

export function LegalAgreement() {
    const userInfo = JSON.parse(localStorage.getItem(appConstants.UserInfo));
    const [legal, setLegal] = useState(null);

    const setLocalStorageLegal = (legal) => {
        localStorage.setItem("legal", JSON.stringify(legal));
    }
    
    const getLocalStorageLegal = () => {
        return JSON.parse(localStorage.getItem("legal", JSON.stringify(legal)));
    }

    const handleLegalUpdate = (updatedLegal) => {
        setLocalStorageLegal(updatedLegal);
        setLegal(updatedLegal);
    }

    useEffect(() => {
        const getLegalData = () => {
            const localLegal = getLocalStorageLegal(); 
            if (localLegal) {
                handleLegalUpdate(localLegal);
            } 
            else {
                getLegal().then((response) => {
                    const decodedResponse = decodeApiResponse(response);
                    handleLegalUpdate(decodedResponse.data);
                }).catch((err) => {
                    console.log("Error :: " + err);
                });
            }
        }
      
        if (!legal && userInfo.userType === appConstants.External) {
            getLegalData();
        }
    }, []);

    return (
        <>
            <EULA userInfo={userInfo} legal={legal} handleLegalUpdate={handleLegalUpdate} />
        </>
    );
}